import { render, staticRenderFns } from "./ConstructionMainFoldersManagment.vue?vue&type=template&id=7b16f2f6&scoped=true&lang=pug&"
import script from "./ConstructionMainFoldersManagment.vue?vue&type=script&lang=ts&"
export * from "./ConstructionMainFoldersManagment.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionMainFoldersManagment.vue?vue&type=style&index=0&id=7b16f2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16f2f6",
  null
  
)

export default component.exports